import { Box, Chip, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AppBarResourceList from "../components/AppBar/ResourceList";
import DateSelector from "../components/DateSelector";
import ResourceListTable from "../components/ResourceList/Table";
import { getData } from "../libs/firebase/firestore/getData";
import { useNavigateToTop } from "../libs/useNavigateToTop";

function ScreenResourceList({}) {
  const navigate = useNavigateToTop();

  // get the resource list id
  const { resourceListId } = useParams();

  // state for the reource list
  const [resourceList, setResourceList] = React.useState([]);

  //state for client name
  const [clientName, setClientName] = React.useState("");

  // state for tag number
  const [tagNumber, setTagNumber] = React.useState("");

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    // get the clients and sites
    getData(
      `resourceLists/${resourceListId}`,
      (data) => {
        setResourceList([...data.plants, ...data.materials]);
        setClientName(data.clientName);
        setTagNumber(data.tagNumber);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  const handleOnTagClick = () => {
    // copy the tag number to the clipboard
    navigator.clipboard.writeText(tagNumber);
  };

  const handleChooseDate = () => {
    setOpen(true);
  };

  return (
    <Box>
      <AppBarResourceList />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Resource List</Typography>
        <Typography variant="subtitle1">This is a list of resources</Typography>

        <Stack
          spacing={2}
          direction={"column"}
          style={{
            margin: "1rem 0",
          }}
        >
          {/* Client name, tag number and site name */}
          <Chip label={clientName} style={{ width: "fit-content" }} />
          <Chip
            onClick={handleChooseDate}
            label={"Today"}
            style={{ width: "fit-content" }}
          />
          {open && (
            <DateSelector
              onSelect={(date) => {
                setOpen(false);
              }}
            />
          )}
          <Chip
            onClick={handleOnTagClick}
            label={tagNumber}
            style={{ width: "fit-content" }}
          />
        </Stack>

        {/* Horizontal divider */}
        <Divider
          sx={{
            my: 2,
          }}
        />
        <ResourceListTable
          // onIncrement={handleOnIncrement}
          // onDecrement={handleOnDecrement}
          // onDelete={handleOnDelete}
          canEdit={false}
          data={resourceList}
        />
      </Box>
    </Box>
  );
}

export default ScreenResourceList;
